<template>
  <div>
    <!--SIMPLE SKELETON-->
    <div
      v-if="type === 'simple'"
      class="py-4 px-2 w-full bg-primary-50 dark:bg-navy-500/90 rounded animate-pulse h-32"
    />
    <!--ACCORDION SKELETON-->
    <div
      v-if="type === 'accordion'"
      class="p-4 bg-primary bg-opacity-40 rounded animate-pulse h-14"
    />
    <!-- TIMER SKELETON -->
    <div
      v-if="type === 'timer'"
      class="p-4 w-full bg-gray-400 rounded animate-pulse h-10"
    />
    <!--CHEM CONTAINER SKELETON-->
    <div v-if="type === 'chemContainer'" class="flex flex-col items-center">
      <div class="chemContainer relative fadein">
        <div class="chemLeftTop" />
        <div class="chemRightTop" />
        <div
          class="
            w-full
            chemLevel
            flex
            justify-center
            items-center
            text-center
            m-0
            transition-all
            duration-500
            bg-gray-400
            animate-pulse
          "
          :style="percentHeight"
        />
      </div>
      <div class="flex flex-col justify-center items-center">
        <h1 class="my-4 bg-gray-400 animate-pulse w-28 h-6 rounded" />
        <p class="mb-2 bg-gray-400 animate-pulse w-24 h-4 rounded" />
        <p class="mb-2 bg-gray-400 animate-pulse w-20 h-4 rounded" />
      </div>
    </div>
    <!-- PIE CHART SKELETON -->
    <div v-if="type === 'pie'" class="w-full rounded-xl shadow-sm pb-4 bg-white dark:bg-navy-800">
      <!-- TITLE SKELETON -->
      <div class="w-full rounded-t p-4 items-center justify-center">
        <div class="bg-gray-200 dark:bg-gray-700 animate-pulse w-32 h-4 rounded mx-auto" />
      </div>
      <!-- PIE SKELETON -->
      <div>
        <div class="flex justify-center items-center pt-4">
          <div class="rounded-full bg-gray-100 dark:bg-gray-700 animate-pulse pie-skeleton relative">
            <div class="absolute inset-0 m-auto rounded-full bg-white dark:bg-navy-700" style="width: 55%; height: 55%;" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingSkeleton",
  props: {
    type: {
      type: String,
      required: false,
      default: "simple",
    },
  },
  data() {
    return {
      percentFull: 0,
      filling: null,
    }
  },
  computed: {
    percentHeight() {
      return `height: ${this.percentFull}%`
    },
  },
  mounted() {
    if (this.type === "chemContainer") this.fillOnMount()
  },
  beforeUnmount() {
    clearInterval(this.filling)
  },
  methods: {
    fillOnMount() {
      let direction = "up"
      this.filling = setInterval(() => {
        if (this.percentFull < 100 && direction === "up") this.percentFull++
        if (this.percentFull === 100) direction = "down"
        if (this.percentFull > 0 && direction === "down") this.percentFull--
        if (this.percentFull === 0) direction = "up"
      }, 100)
    },
  },
};
</script>

<style scoped>
.pie-skeleton {
  height: 85vw;
  width: 85vw;
}
@media screen and (min-width: 640px) {
  .pie-skeleton {
    height: 40vw;
    width: 40vw;
  }
}
@media screen and (min-width: 768px) {
  .pie-skeleton {
    height: 15vw;
    width: 15vw;
  }
}
</style>